<template lang="pug">
v-card
  v-card-title
    .subtitle-1 Template Editor
    v-spacer
    refresh-source-button(:spreadsheet="componentSource")
    v-btn(icon @click="$emit('close-dialog')" title="Close")
      v-icon close

  v-divider

  v-card-text
    v-container(ma-0 pa-0 grid-list-md fluid)
      v-layout
        v-flex(xs4)
          .d-flex.align-center.mb-1
            .overline Component Size
            span.caption.grey--text.ml-1(v-if="!editingSize") {{ sizeLabel }}
            v-btn.ml-1(icon x-small @click="editingSize = !editingSize" :title="editingSize ? 'Done' : 'Edit size'")
              v-icon(small) {{ editingSize ? 'mdi-check' : 'mdi-pencil' }}

          template-size-editor(v-if="editingSize" :template="componentTemplate")

          layer-manager(:template="componentTemplate")

        v-flex(xs4)
          .overline.mb-1 Layer Config

          template(v-if="activeLayer")
            layer-editor(:layer="activeLayer" :source="componentSource" :template="componentTemplate")
          template(v-else)
            p.caption.grey--text Create or select a layer

        v-flex(xs4)
          .overline.mb-1 Preview

          template-previewer.inline-preview(:game="activeGame" :component="component")
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  import LayerManager from './layer/LayerManager.vue'
  import LayerEditor from './layer/LayerEditor.vue'
  import TemplateSizeEditor from './TemplateSizeEditor.vue'
  import TemplatePreviewer from './TemplatePreviewer.vue'
  import RefreshSourceButton from '../source/RefreshSourceButton.vue'

  export default {
    props: ["component"],

    components: {
      TemplatePreviewer,
      TemplateSizeEditor,
      LayerManager,
      LayerEditor,
      RefreshSourceButton,
    },

    data() {
      return {
        editingSize: false,
      }
    },

    computed: {
      ...mapGetters([
        "activeGame",
        "activeLayer",
        "findComponentSheet",
        "findComponentTemplate",
      ]),

      componentSource() {
        return this.findComponentSheet(this.component)
      },

      componentTemplate() {
        return this.findComponentTemplate(this.component)
      },

      sizeLabel() {
        return `(${this.componentTemplate.size.w}in x ${this.componentTemplate.size.h}in)`
      }
    },

    methods: { },
  }
</script>
